/* eslint-disable react-refresh/only-export-components */
import React, { ChangeEvent, FunctionComponent } from 'react';
import { NumberFormatBase, NumberFormatBaseProps } from 'react-number-format';

interface IBANInputProps extends NumberFormatBaseProps {
  // onChange: ChangeEventHandler<HTMLInputElement>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ibanFormat = (value: string) =>
  value
    .replace(/\s+/g, '')
    .replace(/([a-z0-9]{4})/gi, '$1 ')
    .trim()
    .toLocaleUpperCase();

const IBANInput: FunctionComponent<IBANInputProps> = ({
  onChange,
  ...props
}) => (
  <NumberFormatBase
    {...props}
    type='text'
    format={ibanFormat}
    removeFormatting={(value) => value.replace(/\s+/gi, '')}
    isValidInputCharacter={(char) => /^[a-z0-9]$/i.test(char)}
    getCaretBoundary={(value) =>
      Array(value.length + 1)
        .fill(0)
        .map(() => true)
    }
    onValueChange={(values, { event }) =>
      onChange &&
      onChange(
        Object.assign({} as ChangeEvent<HTMLInputElement>, event, {
          target: { name: props.name, value: values.value.toLocaleUpperCase() },
        }),
      )
    }
    onKeyDown={(e) =>
      !/^(?:[a-z0-9]|Backspace|Delete|Home|End|ArrowLeft|ArrowRight|Shift|CapsLock|Control|NumLock|Tab|Paste|Redo|Undo)$/i.test(
        e.key,
      ) && e.preventDefault()
    }
  />
);

export default IBANInput;
